export const download = (url) => {
    const a = document.createElement('a');
    a.href = url;
    a.download = url.split('/').pop();
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};
export const elementsMaxHeight = (elements) => {
    let maxHeight = 0;
    elements.forEach((element) => {
        if (maxHeight < element.clientHeight) {
            maxHeight = element.clientHeight;
        }
    });
    return maxHeight;
};
export const isInViewport = function (elem) {
    const bounding = elem.getBoundingClientRect();
    return (bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + (elem.clientHeight / 3) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth));
};
